import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Loader } from "@egovernments/digit-ui-react-components";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { IconButton, Table, TableContainer } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { yesOrNo } from "../../citizen/TCPForms/data";
import FileUploader from "../../citizen/AVPForms/reusableComponents/FileUploader2";
import { useSelector } from "react-redux";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
const NocPaymentHead = ({
  tenantId,
  formData,
  setTaxHead,
  taxHead,
  handleNoWorkflowPayNOC,
  isEmployee,
  empRole,
  isFeesEligible,
  Modal,
  onSelect,
  isValidEmp,
}) => {
  const { data, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const [moreHeads, setMoreHeads] = useState([]);
  const { documents } = useSelector((state) => state.formMT);
  const { t } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const isRecieptId = formData?.documents?.filter((e) => e.documentType === "reciept")?.[0]?.fileStoreId;
  const isReciept = formData?.documents?.filter((e) => e.documentType === "reciept");
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, "NOC");
  const mapSubFeesTwo = formData?.taxHeadEstimates?.filter((item) => item.taxHeadCode === "BPA_MAP_SUBMISSION_FEE_2")?.[0]?.paymentHeads;
  console.log("mapSubFeesTwo", mapSubFeesTwo);
  const [disabled, setDisabled] = useState(false);
  const inputWidth = 200;
  const nocAdditionalHead = { feeType: "", plotBuildUpArea: "", unit: "", rate: "", amount: "" };
  const handleNoWorkflow = (payload) => {
    if (!isValidEmp) {
      Modal("Invalid Action", "You are not authorized to take action on this application.", "error");
      return;
    }
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...payload,
      workflow,
    };
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("resultFromUpdate", result);
          onSelect("", result?.BPA?.[0]);
          Modal(`Payment details updated`, `Payment details for <strong>(${formData?.applicationNo})</strong> updated successfully!`, "success");
        },
      }
    );
  };
  console.log(formData, isRecieptId, isReciept, "formdatatatarara");

  const defaultValues = {
    ...formData,
    nocPaymentDetails: {
      ...formData?.nocPaymentDetails,
      required: formData?.nocPaymentDetails?.required,
      challanNo: formData?.nocPaymentDetails?.challanNo,
      holderName: formData?.nocPaymentDetails?.holderName,
      bankName: formData?.nocPaymentDetails?.bankName,
      ifscCode: formData?.nocPaymentDetails?.ifscCode,
      additionalHeads: formData?.nocPaymentDetails?.additionalHeads || [nocAdditionalHead],
      utrNo: formData?.nocPaymentDetails?.utrNo,
    },
    // Default row
  };

  const { control, handleSubmit, watch, setValue, reset } = useForm({ defaultValues });

  const { fields: additionalHeads, append, remove } = useFieldArray({
    control,
    name: "nocPaymentDetails.additionalHeads",
  });

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const paymentRequired = watch("nocPaymentDetails.required") === "yes";

  const onSubmit = async (data) => {
    const payload = { ...formData, ...data };
    handleNoWorkflowPayNOC(data);
    //handleNoWorkflow(payload)
  };

  const handleAddInput = () => {
    append({ feeType: "", plotBuildUpArea: "", rate: "", unit: "", amount: "" });
  };

  if (isDataLoading) {
    return <Loader />;
  }

  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">Payment Details</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Payment required?")}`}
                  name="nocPaymentDetails.required"
                  defaultValue={formData?.nocPaymentDetails?.required}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={!isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              {paymentRequired ? (
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Challan No")}
                    control={control}
                    placeholder={t("Enter Challan No.")}
                    name="nocPaymentDetails.challanNo"
                    mandatory
                    maxLength={15}
                    disabled={!isEmployee}
                    defaultValue={formData?.nocPaymentDetails?.challanNo}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            {paymentRequired && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("A/C Holder Name")}
                    control={control}
                    placeholder={t("Enter A/C Holder Name")}
                    name="nocPaymentDetails.holderName"
                    defaultValue={formData?.nocPaymentDetails?.holderName}
                    type="textInput"
                    mandatory
                    disabled={!isEmployee}
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Bank Name")}
                    control={control}
                    placeholder={t("Enter Bank Name")}
                    mandatory
                    type="textInput"
                    name="nocPaymentDetails.bankName"
                    defaultValue={formData?.nocPaymentDetails?.bankName}
                    disabled={!isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}

            {paymentRequired && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label="IFSC Code"
                    control={control}
                    placeholder="Enter IFSC Code"
                    maxLength={13}
                    type="textInput"
                    name="nocPaymentDetails.ifscCode"
                    defaultValue={formData?.nocPaymentDetails?.ifscCode}
                    disabled={!isEmployee}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            {paymentRequired && (
              <TableContainer className="table-container" style={{ marginTop: "10px" }}>
                <Table stickyHeader className="application-table">
                  <thead>
                    <tr>
                      <th className="fit-table-head">Description</th>
                      <th className="fit-table-head">Area</th>
                      <th className="fit-table-head">Unit</th>
                      <th className="fit-table-head">Rate</th>
                      <th className="fit-table-head">Amount</th>
                      {isEmployee && <th className="fit-table-head">Add/Remove</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {additionalHeads.map((field, index) => (
                      <tr key={field.id}>
                        {/* Description */}
                        <td>
                          <InputWrapper
                            hasLabel={false}
                            control={control}
                            name={`nocPaymentDetails.additionalHeads.${index}.feeType`}
                            placeholder="Enter Description"
                            type="textInput"
                            width={inputWidth}
                            disabled={!isEmployee}
                          />
                        </td>

                        {/* Area */}
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            type="textInput"
                            hasLabel={false}
                            control={control}
                            name={`nocPaymentDetails.additionalHeads.${index}.plotBuildUpArea`}
                            placeholder="Enter Area"
                            disabled={!isEmployee}
                          />
                        </td>

                        {/* Unit */}
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            type="textInput"
                            hasLabel={false}
                            control={control}
                            name={`nocPaymentDetails.additionalHeads.${index}.unit`}
                            placeholder="Unit"
                            disabled={!isEmployee}
                          />
                        </td>

                        {/* Rate */}
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            type="textInput"
                            hasLabel={false}
                            control={control}
                            name={`nocPaymentDetails.additionalHeads.${index}.rate`}
                            placeholder="Enter Rate"
                            disabled={!isEmployee}
                          />
                        </td>

                        {/* Amount */}
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            type="textInput"
                            hasLabel={false}
                            control={control}
                            name={`nocPaymentDetails.additionalHeads.${index}.amount`}
                            placeholder="Amount"
                            disabled={!isEmployee}
                          />
                        </td>

                        {/* Action Buttons */}
                        {isEmployee && (
                          <td style={{ display: "flex", gap: "4px" }}>
                            {/* Add Row */}
                            <IconButton
                              color="primary"
                              onClick={() =>
                                append({
                                  feeType: "",
                                  plotBuildUpArea: "",
                                  unit: "",
                                  rate: "",
                                  amount: "",
                                })
                              }
                              aria-label="add"
                            >
                              <AddIcon />
                            </IconButton>

                            {/* Delete Row */}
                            <IconButton color="error" onClick={() => remove(index)} aria-label="delete">
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableContainer>
            )}

            {paymentRequired && isEmployee && (
              <div className="footerContainer3">
                <div className="buttonWrapper">
                  <Button
                    variant="contained"
                    color="success"
                    size="medium"
                    type="submit"
                    disabled={disabled}
                    style={{
                      backgroundColor: "#157CB3",
                      marginRight: "4px",
                      height: "28px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Generate
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    size="medium"
                    style={{
                      backgroundColor: "rgb(21, 124, 179)",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={handleAddInput}
                  >
                    <span style={{ color: "white", display: "flex", alignItems: "center", gap: "4px" }}>
                      <AddIcon />
                      Add
                    </span>
                  </Button>
                </div>
              </div>
            )}
            {/* {paymentRequired && !isEmployee && ( */}

            {!isEmployee && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Enter UTR No")}`}
                    placeholder={`${t("Enter UTR No")}`}
                    name="nocPaymentDetails.utrNo"
                    defaultValue={formData?.nocPaymentDetails?.utrNo}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                {!isRecieptId ? (
                  <Col>
                    <FileUploader label={t("Upload Reciept")} control={control} name="reciept" validationMsg="Upload File" required isMandatory />
                  </Col>
                ) : (
                  <Col>
                    <div>
                      <p>Bank Reciept:</p>
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px" }}
                        onClick={() => getDocumentByFileStoreId(isRecieptId, setIsPreviewLoading)}
                      />
                    </div>
                  </Col>
                )}
              </Row>
            )}
            {isEmployee && formData?.nocPaymentDetails?.utrNo && isRecieptId && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={`${t("Enter UTR No")}`}
                    placeholder={`${t("Enter UTR No")}`}
                    name="nocPaymentDetails.utrNo"
                    defaultValue={formData?.nocPaymentDetails?.utrNo}
                    type="textInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "8px", fontWeight: "500" }}>Bank Receipt:</span>
                    <FaFilePdf
                      color="#a10505"
                      style={{ width: "20px", height: "30px", cursor: "pointer" }}
                      onClick={() => getDocumentByFileStoreId(isRecieptId, setIsPreviewLoading)}
                    />
                  </div>
                </Col>
              </Row>
            )}

            {!isEmployee && (
              <div className="footerContainer">
                <div className="buttonWrapper">
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
                </div>
              </div>
            )}
          </Container>
        </div>
      </form>
    </section>
  );
};

export default NocPaymentHead;
